import { Skeleton } from 'antd'
import React from 'react'
import styled from 'styled-components'

import { InnerTitle } from 'components/InnerTitle'
import { ProductCard } from 'features/products/components/ProductCard'
import { Product } from 'features/products/types'

type Props = {
  hierachyProductsData?: Product[]
}

const ProductSelector: React.FC<Props> = ({ hierachyProductsData }) => {
  const validProducts = (hierachyProductsData ?? []).sort(
    (a, b) => b.review_count - a.review_count,
  )

  if (!hierachyProductsData) {
    return (
      <ProductItemContainer>
        {[...Array(3)].map((_, index) => (
          <SkeletonCard key={index}>
            <Skeleton active paragraph={{ rows: 8 }} title={false} />
          </SkeletonCard>
        ))}
      </ProductItemContainer>
    )
  }

  if (validProducts.length === 0) {
    return (
      <div>
        <InnerTitle style={{ textAlign: 'center' }}>
          No products for this selection
        </InnerTitle>
      </div>
    )
  }

  return (
    <ProductItemContainer>
      {validProducts.map((product) => (
        <ProductCard key={product.uuid} product={product} />
      ))}
    </ProductItemContainer>
  )
}

export default ProductSelector

const ProductItemContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 260px;
  grid-template-rows: auto auto auto auto auto auto;
  gap: 16px;
  overflow-x: auto;
  padding: 10px 0;
`

const SkeletonCard = styled.div`
  min-width: 260px;
  max-width: 260px;
  background: white;
  border-radius: var(--border-radius);
  border: 1px solid #e8e8e8;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;
  grid-row: 1 / -1;
`
